<template>
  <ChartBase
    title="Daily Sales (Last 90 Days)"
    :subtitle="totalSalesUSD || '-'"
    :loading="loading"
    :error="error"
  >
    <BarChart
      class="chart-admin-ninety-day-sales line-chart"
      :chart-options="chartOptions"
      :chart-data="chartData"
    />
  </ChartBase>
</template>

<script>
import AdminChartService from '@/services/AdminChartService'
import { SuperAdminBarChartOptions } from '@/constants/ChartOptions'
import ChartBase from '@/components/ChartBase.vue'

import _get from 'lodash/get'
import _min from 'lodash/min'
import _max from 'lodash/max'
import _sum from 'lodash/sum'

import { Bar as BarChart } from 'vue-chartjs/legacy'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {
  name: 'ChartAdminNinetyDaySales',
  components: {
    ChartBase,
    BarChart,
  },
  data() {
    return {
      loading: true,
      totalSalesUSD: null,
      error: null,
      chartData: {
        labels: [],
        datasets: [],
      },
      chartOptions: SuperAdminBarChartOptions,
    }
  },
  computed: {},
  async mounted() {
    this.error = null
    this.loading = true
    try {
      const { data: chartData } = await AdminChartService.getChart(
        'admin-sales-90'
      )
      this.chartData.labels = chartData.labels
      this.chartData.datasets = chartData.datasets
      await this.setChartStepSize(chartData.datasets[0].data)
      await this.setTotalSales(chartData.datasets[0].data)
    } catch (error) {
      let errorCode = _get(error, 'response.status')
      this.error =
        errorCode === 403
          ? 'Sorry, you do not have access to view this chart.'
          : _get(error, 'response.data.message', 'Could not load this chart')
    } finally {
      this.loading = false
    }
  },
  methods: {
    setChartStepSize(chartDataSet) {
      let min = _min(chartDataSet)
      let headroom = 1
      let max = _max(chartDataSet) * headroom

      this.chartOptions.scales.y.suggestedMax = max
      let approxStepSize = (max - min) / 3
      let roundToNearest = 20
      this.chartOptions.scales.y.ticks.stepSize =
        Math.ceil(approxStepSize / roundToNearest) * roundToNearest
    }, // setChartStepSize
    setTotalSales(chartDataSet) {
      let sum = _sum(chartDataSet)
      this.totalSalesUSD = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      }).format(sum)
    }, // setTotalSales
  },
}
</script>

<style scoped>
.line-chart {
  height: 200px;
}
</style>
